import axios from '@/services/apiAxios';
import queryString from '@/utils/queryString';

export default {
    namespaced: true,
    state: {
        accountTypes: [],
    },
    mutations: {
        setAccountTypes(state, payload) {
            state.accountTypes = payload;
        }
    }, 
    actions: {
        fetchAccountTypes({ commit, rootState, dispatch }, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `${rootState.corporate.routePrefix}/account-types?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setAccountTypes', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                }
                );
            })
        }

    }
}